import axios from 'axios';
import { store } from '../store';
import { storeCsrfToken } from '../actions/cookiesSettings'


class Api {
  constructor() {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = store.getState().cookieSettings?.csrfToken;
    axios.defaults.withCredentials = true;

    axios.interceptors.response.use(response => {
      const newToken = response.config.headers['X-XSRF-TOKEN'];
      store.dispatch(storeCsrfToken(newToken))
      return response
    })
  }

  get(url, params) {
    return axios.get(url, params)
  }

  post(url, params, data) {
    return axios.post(url,params,data)
  }

  patch(url, params, data) {
    return axios.patch(url,params,data)
  }

  delete(url, params) {
    return axios.delete(url,params)
  }
}

export default Api;
